import {Typography} from '@yandex-delivery/blocks'
import React from 'react'
import {useController, useFormContext} from 'react-hook-form'

import {TextInput} from '../../../components/Input/TextInput'
import type {TextInputWidgetProps as Props} from '../../types'
import * as classes from './TextInput.classes'

export const TextInputWidget = ({config: {height, placeholder, form_state_key}}: Props): React.ReactElement => {
  const {control} = useFormContext()
  const {
    fieldState: {error, invalid},
  } = useController({control, name: form_state_key})
  return (
    <>
      <TextInput height={height} name={form_state_key} placeholder={placeholder} />
      {invalid && (
        <Typography className={classes.errorMessage} color="error" variant="caption2">
          {error?.message}
        </Typography>
      )}
    </>
  )
}
